import { UIText1, UIText2 } from '@cian/ui-kit/typography';
import * as React from 'react';

import * as styles from './MultipinPreviewError.css';
import { ETestId } from '../../../../../../common/constants';

interface IMultipinPreviewErrorProps {
  onRetry(): void;
}

/** Объявления мультипина не загрузились: текст и «Обновить». Крестик - в шапке шторки. */
export const MultipinPreviewError = ({ onRetry }: IMultipinPreviewErrorProps) => (
  <div className={styles['root']} data-testid={ETestId.MultipinPreviewError}>
    <UIText2 color="gray60_100" textAlign="center" display="block">
      Не удаётся загрузить объявления
    </UIText2>
    <button type="button" className={styles['retry']} onClick={onRetry}>
      <UIText1 color="primary_100">Обновить</UIText1>
    </button>
  </div>
);

MultipinPreviewError.displayName = 'MultipinPreviewError';
